// ---------
// NOTE
// ---------
// Some properties are added for completeness, but prefer not to use them. Keep them in comment for now, until needed.
// An example of this is to prefer 'flex-start' over 'start', since 'flex-start' keeps the row-reverse direction
// into account.

export enum FlexboxDirection {
  Row = 'row',
  RowReverse = 'row-reverse',
  Column = 'column',
  ColumnReverse = 'column-reverse'
}

export enum FlexboxAlignItems {
  Normal = 'normal',
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
  Stretch = 'stretch',
  Baseline = 'baseline',
  // FirstBaseline = 'first-baseline',
  // LastBaseline = 'last-baseline',
  // Safe = 'safe',
  // Unsafe = 'unsafe'
  // Start = 'start',
  // End = 'end',
}

export enum FlexboxJustifyContent {
  Normal = 'normal',
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
  Stretch = 'stretch',
  SpaceBetween = 'space-between',
  SpaceAround = 'space-around',
  SpaceEvenly = 'space-evenly',
  // Start = 'start',
  // End = 'end',
  // Left = 'left',
  // Right = 'right',
  // SafeCenter = 'safe-center',
  // UnsafeCenter = 'unsafe-center'
}

export enum FlexboxGapSize {
  None = 'none',
  XSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl'
}
